module.exports = __webpack_public_path__ + "img/service-time.983c15f2.svg";